import { Component, OnInit, EventEmitter, Output, OnDestroy } from '@angular/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbCarouselConfig
} from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
declare var $: any;
import { Router, ActivatedRoute } from '@angular/router';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import { ToastrService } from 'ngx-toastr';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { environment } from '../../../environments/environment';
import { KycService } from '../../services/kyc.service';
import swal from 'sweetalert2';
import { MessagingService } from '../../shared/messaging.service';
import { BehaviorSubject, Subject } from 'rxjs';
@Component({
  selector: 'app-uw-banker-header',
  templateUrl: './uw-banker-header.component.html',
  styleUrls: ['./uw-banker-header.component.css']
})
export class UwBankerHeaderComponent implements OnInit, OnDestroy {
  @Output() toggleSidebar = new EventEmitter<void>();
  private notificationSubscription;
  public config: PerfectScrollbarConfigInterface = {};

  public showSearch = false;

  messageText: string;
  messages: Array<any>;
  socket: SocketIOClient.Socket;
  notifications: any;

  counterCount: any;
  activeNode: any;
  blockNumber: any;
  txnDetails: any;
  blkNumber: any;
  listOftxns: any;

  private timer;
  alive = true;
  counterData: any;
  latestBlock: any;
  mess: any;
  userId: any;
  user: any;
  action: any;

  userEmail: any;
  profilePic: any;
  URL: any;
  imageUrl: any;
  message;
  FCMtokenData: any;
  messageResponse: any;

  currentMessage = new BehaviorSubject(null);
  notifyMsg: any;
  fcm_token: any;
  customerID: any;
  alertsInfo: any;
  allNotifications: any;
  private unsubscribe$ = new Subject();
  constructor(private modalService: NgbModal, private toastr: ToastrService, private router: Router, private _httpService: KycService,
    private messagingService: MessagingService) {
    // this.socket = io.connect(environment.notifyUrl);
    // console.log('connected to notify');
  }

  ngOnInit() {
    document.body.classList.remove('bg-img');
    this.userId = localStorage.getItem('bankerId');
    this.user = localStorage.getItem('name'); 
    this.userEmail = localStorage.getItem('bankerEmail');
    this.customerID = localStorage.getItem('customerID');
    this._httpService.getProfilePicHash(this.userEmail).subscribe(
      data => {
          this.profilePic = (data);
          console.log('pp', this.profilePic);
          const dataVal = this.profilePic.items;
          for (const item of dataVal) {
              this.URL = item.URL;
              console.log('URL', this.URL);
          }
          if (this.profilePic.responseStatus === 200) {
              console.log('200');
                console.log('URL ddd', this.URL);
                this.imageUrl = this.URL;
          }
          } ,
          error => {
            this.handleError(error);
          },
      () => console.log('created employee', this.profilePic));
      this.requestPermision();
      this.getAllNotifications();
    }

    getAllNotifications() {
      console.log('inside get all notifications');
      console.log('customerID', this.customerID);
      this.messagingService.getAllAlerts(this.customerID).subscribe(
        data => {
            this.alertsInfo = (data);
            console.log('alerts', this.alertsInfo);
            const dataVal = this.alertsInfo.items;
            console.log('dataVal', dataVal);
            for (const item of dataVal) {
              this.allNotifications = item.notification;
              console.log('notifications', this.allNotifications);
            }
            } ,
            error => {
              this.handleError(error);
            },
        () => console.log('created employee', this.alertsInfo));

    }
    requestPermision() {
      this.messagingService.requestPermission().subscribe(
        data => {
            this.fcm_token = (data);
            console.log('Token received', this.fcm_token);
            if (this.fcm_token !== null) {
              console.log('inside iff');
              localStorage.setItem('FCMtoken', this.fcm_token);
              this.getMessages();
            }
          } ,
          error => {
            console.log('error', error);
            this.toastr.warning('Messaging: Notifications have been blocked. Please change the browser settings to receive notifications');
          },
      () => console.log('Subscribe token', this.fcm_token));
    }
  
    getMessages() {
      this.messagingService.getMessages().subscribe(
        data => {
            this.FCMtokenData = (data);
            console.log('FCMtokenData', this.FCMtokenData);
            if(this.FCMtokenData.responseStatus === 200) {
              this.receiveMessages();
            }
          } ,
          error => {
            this.handleError(error);
          },
      () => console.log('Subscribe token', this.FCMtokenData));
    }
    receiveMessages() {
      this.messagingService.receiveMessage().takeUntil(this.unsubscribe$).subscribe(
        data => {
            this.messageResponse = (data);
            console.log('messages ++++', this.messageResponse.data.message);
            this.currentMessage.next(this.messageResponse.data.message);
            this.notifyMsg = this.currentMessage.value;
            console.log('message++', this.notifyMsg);
            this.toastr.success(this.notifyMsg);
          } ,
          error => {
            this.handleError(error);
          },
      () => console.log('Subscribe token', this.FCMtokenData));
    }

    onEdit(){
      this.router.navigate(['/uw/user-profile']);
      
    }

    onLogout() {
      this._httpService.logOut().subscribe(
        data => {
          console.log(data)
            } ,
        error => {
          console.log(error)
          },
        () => console.log('created employee', ));
      console.log('inside logout');
      localStorage.removeItem('currentUser');
      localStorage.removeItem('bankerId');
      localStorage.removeItem('name');
      localStorage.removeItem('bankerName');
      localStorage.removeItem('bankerEmail');
      localStorage.removeItem('customerId');
      localStorage.removeItem('bankerRole');
      localStorage.removeItem('userEmail');
      
      this.router.navigate(['/login']);
    }
    ngOnDestroy(): void {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    }
    handleError(error) {
      this.imageUrl = 'assets/images/users/pp.png';
      console.log('error', error.error);
      console.log('status code', error.responseStatus);
      if (error.responseStatus === 400) {
        console.log('inside if');
        // swal({
        //     
        //     text: error.error,
        //     type: 'warning',
        //     showCancelButton: false,
        //     confirmButtonColor: '#535BE2',
        //     cancelButtonColor: '#FF7E39',
        //     confirmButtonText: 'OK',
        //   }).then((confirm) => {
        //         if (confirm) {
        //           this.router.navigate(['/buyer/mr']);
        //         }
        //       });
      }
      if (error.responseStatus === 401) {
          console.log('inside if');
          console.log(error);
          console.log(error.error);
          swal({
              
              text: error.message,
              type: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#535BE2',
              cancelButtonColor: '#FF7E39',
              confirmButtonText: 'OK',
            }).then((confirm) => {
                  if (confirm) {
                    this.router.navigate(['/login']);
                  }
                });
        }
        if (error.responseStatus === 500) {
          console.log('inside if');
          swal({
            
            text: error.error,
            type: 'success',
            showCancelButton: false,
            confirmButtonColor: '#535BE2',
            cancelButtonColor: '#FF7E39',
            confirmButtonText: 'OK',
          }).then((confirm) => {
                if (confirm) {
                  // this.router.navigate(['/buyer/mr']);
                }
              });
        }
    }
  }
